import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import DatePicker from '../../../shared/DatePicker/DatePicker.jsx';

export const TilesDigestDateInput = ({ value, onChange }) => {
  const [date, setDate] = useState(
    new Date(value.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3')),
  );

  return (
    <DatePicker
      value={date}
      mode="single"
      size="1.09"
      minDate="today"
      onChange={newDate => {
        setDate(newDate);
        onChange(moment(newDate[0]).format('DD-MM-YYYY'));
      }}
    />
  );
};

TilesDigestDateInput.defaultProps = {
  minDate: moment(),
  maxDate: moment()
    .add(11, 'month')
    .endOf('month'),
};

TilesDigestDateInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
};
